import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api';

const STATUS_LABELS = { new: 'Новая', pending: 'На подписи', paid: 'Оплачена', rejected: 'Отклонена' };

export default function Project() {
  const { name } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/payments/project/${encodeURIComponent(name)}`).then(r => setData(r.data)).finally(() => setLoading(false));
  }, [name]);

  if (loading) return <div className="loading-text">Загрузка...</div>;
  if (!data) return <div className="empty-state">Нет данных</div>;

  const total = data.stats.reduce((s, r) => s + parseFloat(r.total || 0), 0);
  const paid = data.stats.find(s => s.status === 'paid');

  return (
    <div>
      <div className="toolbar">
        <Link to="/payments" className="btn-secondary btn-sm">← К заявкам</Link>
        <h2 style={{ marginLeft: 8 }}>{name}</h2>
      </div>

      <div className="stats-row">
        <div className="stat-card">
          <div className="stat-value">{data.payments.length}</div>
          <div className="stat-label">Всего заявок</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{parseInt(total).toLocaleString('ru')} ₽</div>
          <div className="stat-label">Оборот по всем статусам</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{parseInt(paid?.total || 0).toLocaleString('ru')} ₽</div>
          <div className="stat-label">Оплачено</div>
        </div>
        {data.stats.map(s => (
          <div className="stat-card" key={s.status}>
            <div className="stat-value">{s.count}</div>
            <div className="stat-label">{STATUS_LABELS[s.status] || s.status}</div>
          </div>
        ))}
      </div>

      <h3 className="mb-2">По направлениям</h3>
      <div className="table-wrap mb-2">
        <table>
          <thead><tr><th>Направление</th><th>Сумма</th></tr></thead>
          <tbody>
            {data.directions.map(d => (
              <tr key={d.direction}><td>{d.direction}</td><td>{parseInt(d.total).toLocaleString('ru')} ₽</td></tr>
            ))}
          </tbody>
        </table>
      </div>

      <h3 className="mb-2">Заявки</h3>
      <div className="table-wrap">
        <table>
          <thead><tr><th>#</th><th>Направление</th><th>Статья</th><th>Сумма</th><th>Статус</th><th>Создана</th></tr></thead>
          <tbody>
            {data.payments.map(p => (
              <tr key={p.id}>
                <td>{p.id}</td>
                <td>{p.direction}</td>
                <td>{p.article}</td>
                <td>{parseFloat(p.amount).toLocaleString('ru')} ₽</td>
                <td><span className={`badge badge-${p.status}`}>{STATUS_LABELS[p.status]}</span></td>
                <td>{new Date(p.created_at).toLocaleDateString('ru')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
